import React from "react";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import withRouter from "../../../../../withRouter";
import BaseListPage from "../../../../../base/BaseListPage";
import BasicEarningsPresenter from "./BasicEarningsPresenter";
import TablePayroll from "../../../Payroll/table-payroll/TablePayroll";
import Progress from "../../../../../components/Progress";

class BasicEarningsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      objects: [],
      tableHeaders: {},
      isLoading: true,
    };
    this.presenter = new BasicEarningsPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "payroll";
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, tableHeaders, isLoading } = this.state;
    const { fetchPayrolls, panelInfo } = this.props;

    console.log("isLoading", isLoading);

    console.log("objects==990", objects);

    console.log("PANELLLL INFO", panelInfo);

    if (!schema) return <Progress />;

    return (
      <>
        <div className="p-3 mt-4">
          <TablePayroll
            tableHeader={tableHeaders?.tableHeader}
            primarySubHdr={tableHeaders?.primarySubHdr}
            headersKey={tableHeaders?.convertedHeaders}
            isValueOnly={true}
            isLoading={isLoading}
            object={objects}
          />
        </div>
      </>
    );
  }
}

export default withRouter(BasicEarningsPage);
